// PDF documents scale breakpooint
export const SCREEN_WIDTH_BREAKPOINT = 975;

export const ZOOM_STEP = 0.01;
export const MIN_ZOOM_SCALE = 0.28;
export const MAX_ZOOM_SCALE = 2.0;
export const DEFAULT_ZOOM_SCALE = 1.0;